import { NgModule } from '@angular/core';
import { EscapeHtmlPipe } from './safe-html.pipe';

@NgModule({
  declarations: [EscapeHtmlPipe],
  exports: [EscapeHtmlPipe],
})
export class EscapeHtmlPipeModule {}
